import { AritoFormV2, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import type { TaxGroup } from '@/types/schemas/nhom-thue.type';
import { initialValues, type FormValues } from '../schemas';
import BasicInfo from './BasicInfo';

interface FormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: FormValues) => void;
  formMode?: 'add' | 'edit' | 'view';
  mode?: 'add' | 'edit' | 'view';
  initialData?: TaxGroup | null;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
  zIndex?: number;
}

const FormDialog = ({
  open,
  onClose,
  onSubmit,
  formMode,
  mode,
  initialData,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick,
  zIndex
}: FormDialogProps) => {
  const resolvedMode = mode || formMode || 'add';

  const handleSubmit = async (data: FormValues) => {
    await onSubmit(data);
  };

  const title = resolvedMode === 'add' ? 'Thêm nhóm thuế' : resolvedMode === 'edit' ? 'Sửa nhóm thuế' : 'Xem nhóm thuế';

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title={title}
      maxWidth='md'
      disableBackdropClose={true}
      disableEscapeKeyDown={true}
      zIndex={zIndex}
    >
      <AritoFormV2<FormValues>
        mode={resolvedMode}
        hasAritoActionBar={false}
        onSubmit={handleSubmit}
        initialData={(initialData || initialValues) as Partial<FormValues>}
        className='w-full md:min-w-[500px] lg:min-w-[600px]'
        headerFields={<BasicInfo formMode={resolvedMode} />}
        bottomBar={
          <BottomActionBarV2
            mode={resolvedMode}
            onAdd={onAddButtonClick}
            onEdit={onEditButtonClick}
            onDelete={onDeleteButtonClick}
            onCopy={onCopyButtonClick}
            onClose={onClose}
          />
        }
      />
    </DialogV2>
  );
};

export default FormDialog;
